import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  makeStyles,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { ORDER_STATE_LABELS } from '../../../../../../commons/const/orderStateLabels';
import { getOrderStateLabel, getOrderStateLabelEs } from '../../../utils/orderState';
import { getPaymentStateLabel } from '../../../utils/paymentsState';

const useStyles = makeStyles((theme) => ({
  confirmButton: {
    backgroundColor: '#00AEEF',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0096d1',
    },
    '&.Mui-disabled': {
      backgroundColor: '#ccc',
      color: '#666',
    },
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  subtitle: string;
  orderStatusFrom?: string;
  orderStatusTo?: string;
  paymentStatusFrom?: string;
  paymentStatusTo?: string;
  checkboxText?: string;
  isStripe: boolean
}

export const StatusChangeModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  title,
  subtitle,
  orderStatusFrom,
  orderStatusTo,
  paymentStatusFrom,
  paymentStatusTo,
  checkboxText,
  isStripe
}) => {
  const classes = useStyles();

  const [confirmationChecked, setConfirmationChecked] = useState(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmationChecked(event.target.checked);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography style={{ marginBottom: 24 }}>{subtitle}</Typography>

        {orderStatusFrom && orderStatusTo && (
          <>
            <Typography variant="body2" style={{ fontWeight: 'bold' }}>
              Estado de la orden:
            </Typography>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 8,
                marginTop: 8,
                marginLeft: 24,
              }}
            >
              <Typography>{getOrderStateLabelEs(orderStatusFrom)}</Typography>
              <ArrowForwardIcon fontSize="small" style={{ margin: '0 8px' }} />
              <Typography>{getOrderStateLabel(orderStatusTo)}</Typography>
            </div>
          </>
        )}

        {paymentStatusFrom && paymentStatusTo && (
          <>
            <Typography variant="body2" style={{ fontWeight: 'bold', marginTop: 12 }}>
              Estado de la orden:
            </Typography>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 8,
                marginTop: 8,
                marginLeft: 24,
              }}
            >
              <Typography>{getPaymentStateLabel(paymentStatusFrom)}</Typography>
              <ArrowForwardIcon fontSize="small" style={{ margin: '0 8px' }} />
              <Typography>{getPaymentStateLabel(paymentStatusTo)}</Typography>
            </div>

            <Typography variant="body2" style={{ fontWeight: 'bold', marginTop: 12 }}>
              Previo a confirmar asegurarse de:
            </Typography>

            <div style={{ marginTop: 10 }}>
              <input
                id="confirm-payment"
                type="checkbox"
                checked={confirmationChecked}
                onChange={handleCheckboxChange}
                style={{ marginRight: 8 }}
              />
              <label htmlFor="confirm-payment">{checkboxText}</label>
              <div style={{ marginTop: 8, marginLeft: 24 }}>
                <a
                  href={isStripe ? "https://dashboard.stripe.com/login?redirect=%2Ftest%2Fpayments" : 'https://merchant.bamboopayment.com/#/home'}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', marginTop: 6, color: '#0070f3' }}
                >
                  {isStripe ? 'Ir al panel de Stripe' : 'Ir al panel de Bamboo'}
                </a>
              </div>
            </div>
          </>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'flex-end' }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={onConfirm}
          className={classes.confirmButton}
          disabled={!!checkboxText && !confirmationChecked}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
